import {Flex, Typography, Button, Spin} from 'antd';
import {modelListGridId, useStoredGridState} from '../../../../store/grid';
import {ModelFilter, ModelFilterState} from '../../model/filter';
import {Search} from '../../../core/Search/Search';
import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {MRAppRoutes} from '../../../router/routes';
import {useModelListBasedOnUserType} from '../../../../store/model';
import {isExternalUser} from '../../../../permissions/usePermissions';
import {HeartOutlined} from '@ant-design/icons';

export const FilterForm = () => {
  const externalUser = isExternalUser();

  const navigate = useNavigate();
  const gridState = useStoredGridState<ModelFilterState>(modelListGridId);
  const list = useModelListBasedOnUserType(externalUser);

  const handleSearchChange = useCallback(
    (search: string) => {
      if (gridState.page !== 0) {
        gridState.setPage(0);
      }
      gridState.setSearch(search);
    },
    [gridState],
  );

  const handleFilterChange = useCallback(
    (filterState: ModelFilterState) => {
      if (gridState.page !== 0) {
        gridState.setPage(0);
      }
      gridState.setFilter(filterState);
    },
    [gridState],
  );

  const handleSearch = useCallback(() => {
    navigate(MRAppRoutes.MODEL_LIST);
  }, [navigate]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleSearch();
      }
    },
    [handleSearch],
  );

  return (
    <Flex
      vertical
      style={{alignSelf: 'center', width: '100%', maxWidth: '866px', marginTop: '-30px'}}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <Flex justify="space-between" style={{width: '100%', marginBottom: '12px'}}>
        <Typography.Title level={3} style={{margin: 0, fontSize: '28px', lineHeight: '28px', fontWeight: 400}}>
          Search for HEOR Models
        </Typography.Title>
        <Button
          type="link"
          icon={<HeartOutlined style={{strokeWidth: '2px'}} />}
          style={{fontWeight: 'bold', color: gridState.viewFavorites ? '#00857c' : undefined}}
          onClick={() => {
            gridState.setViewFavorites(true);
            navigate(MRAppRoutes.MODEL_LIST);
          }}
        >
          View Favorites
        </Button>
      </Flex>
      {list ? (
        <>
          <Search
            value={gridState.search}
            onValueChange={handleSearchChange}
            onPressEnter={handleSearch}
            width="full"
            tourId="home-search-input"
            placeholder="Type Model Name, Trial Number, or MKV"
          />
          <div data-tour-id="home-filters" style={{marginTop: '20px'}}>
            <ModelFilter models={list} filter={gridState.filter} onFilterChange={handleFilterChange} isHorizontal />
          </div>
          <Button
            type="primary"
            style={{width: '100px', marginTop: '40px', alignSelf: 'center'}}
            onClick={handleSearch}
          >
            Search
          </Button>
        </>
      ) : (
        <Spin size="large" style={{display: 'block', margin: '40px auto'}} />
      )}
    </Flex>
  );
};
